
<template>
  <div class="svg-container-logo" :class="[size]">
    <svg
      preserveAspectRatio="xMinYMin meet"
      height="100%"
      viewBox="0 0 560 560"
      style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
      >
      <path
        d="M0.5,279.775L560.5,279.775M1.085,298.088L559.886,261.463M9.982,352.252L550.901,207.313M15.287,369.79L545.568,189.784M2.866,316.324L558.075,243.23M5.836,334.405L555.076,225.154M21.728,386.944L539.1,172.641M29.276,403.639L531.525,155.957M37.9,419.805L522.875,139.805M47.563,435.373L513.186,124.253M58.224,450.275L502.502,109.368M69.837,464.448L490.867,95.214M82.351,477.831L478.331,81.851M95.714,490.367L464.947,69.337M109.868,502.002L450.775,57.724M124.753,512.687L435.873,47.064M140.305,522.375L420.305,37.401M156.457,531.025L404.139,28.776M173.141,538.6L387.443,21.228M190.284,545.068L370.29,14.787M207.813,550.401L352.752,9.483M225.654,554.576L334.904,5.336M243.73,557.575L316.824,2.366M261.963,559.386L298.588,0.585M280.275,560L280.275,0M298.588,559.415L261.962,0.614M316.824,557.634L243.729,2.425M334.905,554.664L225.654,5.424M352.752,550.517L207.813,9.599M370.29,545.213L190.284,14.932M387.443,538.772L173.141,21.4M404.139,531.224L156.457,28.975M420.305,522.6L140.305,37.625M435.872,512.936L124.753,47.314M450.774,502.276L109.868,57.998M464.948,490.663L95.714,69.633M478.331,478.149L82.351,82.169M490.867,464.786L69.836,95.552M502.502,450.632L58.224,109.725M513.187,435.747L47.564,124.627M522.874,420.195L37.9,140.195M531.525,404.043L29.276,156.361M539.1,387.359L21.727,173.056M545.568,370.216L15.287,190.21M550.901,352.687L9.982,207.748M555.076,334.846L5.836,225.595M558.075,316.77L2.866,243.676M559.885,298.537L1.084,261.912"
        fill="none"
        fill-rule="nonzero"
        :stroke
        :stroke-width="`${strokeWidth}px`"
        />
    </svg>
  </div>
</template>
<script setup lang="ts">
import { Color, ColorMappingBG, type TypeColor, type TypeSize, Size } from '../../interfaces'
export interface Props {
  color?: string
  size?: TypeSize
  stroke?: string
  strokeWidth?: number
}

withDefaults(defineProps<Props>(), {
  color: Color.white,
  size: Size.lg,
  stroke: '#fed68e',
  strokeWidth: 1.13,
})

</script>
<style lang="scss" scoped>
.sm {
  width: fit-content;
}
</style>
